import React, {Fragment} from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import {set, get} from '../../../utils/dotutils';
import Select from "../../form/Select";
import isEqual from "lodash-es/isEqual";
import {getComponentConfig} from "../../../utils/components";
import Box from "../../layout/Box";
import TabContent from "../../layout/TabContent";
import Tabs from "../../layout/Tabs";
import Icon from "../../form/Icon";
import Button from "../../form/Button";
import Modal from "../../layout/Modal";

class NoneFieldEditor extends React.Component {
    render() {
        return (
            <div>

            </div>
        );
    }
}

class AttributeFieldEditor extends React.Component {
    render() {
        return (
            <div>

            </div>
        );
    }
}

class PluginFieldFieldEditor extends React.Component {

    state = {
        objectConfig: {},
        fieldoptions: [],
        isLoading: true
    }

    componentDidMount() {
        this.loadConfig(this.props.object);
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps, this.props)) {
            if (this.props.object) {
                this.loadConfig(this.props.object);
            }
        }
    }

    loadConfig = async (object) => {
        this.setState({objectConfig: {}, fieldoptions: [], isLoading: false}, async () => {
            if (object && this.props.object) {
                const config = await getComponentConfig(this.props.object);
                if (object === this.props.object) {
                    let fields = config.fielddefs || {};
                    const fieldoptions = [];
                    Object.keys(fields).map((fieldname) => {
                        fieldoptions.push({key: fieldname});
                    });
                    this.setState({objectConfig: config, fieldoptions, isLoading: false});
                }
            }
        });
    }

    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-6">
                        <Select storeType={"remote"} component="ComponentConfig" objectValue={false} valueKey={"name"} labelKey={"name"} name={"componentconfig.fielddefs." + this.props.fieldname + ".object"} value={this.props.object} label="Object"
                                saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.fielddefs." + this.props.fieldname + ".object")}/>
                    </div>
                    <div className="col-md-6">
                        <Select storeType={"local"} isLoading={this.state.isLoading} objectValue={false} options={this.state.fieldoptions} valueKey={"key"} labelKey={"key"} name={"componentconfig.fielddefs." + this.props.fieldname + ".field"} value={this.props.field} label="Field"
                                saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.fielddefs." + this.props.fieldname + ".field")}/>
                    </div>
                </div>
            </Fragment>
        );
    }
}

class ObjectFieldEditor extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select storeType={"remote"} component="ComponentConfig" objectValue={false} valueKey={"name"} labelKey={"name"} name={"componentconfig.fielddefs." + this.props.fieldname + ".object"} value={this.props.object} label="Object"
                                saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.fielddefs." + this.props.fieldname + ".object")}/>
                    </div>
                </div>
            </Fragment>
        );
    }
}

class ComponentListFieldEditor extends React.Component {
    render() {
        return (
            <Fragment>
                <div className="row form-row">
                    <div className="col-md-12">
                        <Select storeType={"remote"} component="ComponentConfig" objectValue={false} valueKey={"name"} labelKey={"name"} name={"componentconfig.fielddefs." + this.props.fieldname + ".objects"} value={this.props.objects} label="Objects"
                                saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.fielddefs." + this.props.fieldname + ".objects")}/>
                    </div>
                </div>
            </Fragment>
        );
    }
}

class ListFieldEditor extends React.Component {
    render() {
        return (
            <div>

            </div>
        );
    }
}

class ComponentTypeEditor extends React.Component {
    render() {
        return (
            <div>

            </div>
        );
    }
}

class ComponentDecoratorTypeEditor extends React.Component {
    render() {
        return (
            <Fragment>
                <Select storeType={"remote"} component="ComponentConfig" objectValue={false} valueKey={"name"} labelKey={"name"} name={"componentconfig.target"} value={this.props.componentconfig.target} label="Target"
                        saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.target")}/>
            </Fragment>
        );
    }
}

class AdapterTypeEditor extends React.Component {
    render() {
        return (
            <Fragment>
                <Select storeType={"remote"} component="ComponentConfig" objectValue={false} isMulti={true} valueKey={"name"} labelKey={"name"} name={"componentconfig.objects"} value={this.props.componentconfig.objects} label="Objects"
                        saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.objects")}/>
            </Fragment>
        );
    }
}

const types = [
    {key: "attribute", Editor: AttributeFieldEditor},
    {key: "pluginfield", Editor: PluginFieldFieldEditor},
    {key: "object", Editor: ObjectFieldEditor},
    {key: "componentlist", Editor: ComponentListFieldEditor},
    {key: "list", Editor: ListFieldEditor}
];

const nsoptions = [
    {key: "BooqBinder\\Base\\"},
    {key: "BooqBinder\\Components\\Core\\"}
];

const objectoptions = {
    "BooqBinder\\Base\\": [
        {key: "Component"},
        {key: "ComponentDecorator"},
        {key: "Adapter"},
    ]
};

const componenttypes = [
    {key: "Component", Editor: ComponentTypeEditor},
    {key: "ComponentDecorator", Editor: ComponentDecoratorTypeEditor},
    {key: "Adapter", Editor: AdapterTypeEditor}
];

class Field extends React.Component {
    render() {
        const TypeEditor = (types.find((item) => item.key === this.props.type) || {}).Editor || NoneFieldEditor;
        return <Fragment>
            <div className="row form-row">
                <div className="col-md-12">
                    <Select storeType={"local"} objectValue={false} options={types} valueKey={"key"} labelKey={"key"} name={"componentconfig.fielddefs." + this.props.fieldname + ".type"} value={this.props.type} label="Type"
                               saveChanges={this.props.setFieldValue} {...this.props.getFieldProps("componentconfig.fielddefs." + this.props.fieldname + ".type")}/>
                </div>
            </div>
            <TypeEditor {...this.props}/>
        </Fragment>
    }
}

class View extends React.Component {

    render() {
        const fields = Object.keys(this.props.componentconfig.fielddefs || {});
        const props = {...this.props.getFieldProps("views." + this.props.viewname + "")};
        const view = this.props.view || [];

        const fieldoptions = [];
        fields.map((fieldname) => {
            if (view.indexOf(fieldname) === -1) {
                fieldoptions.push({key: fieldname});
            }
        });

        return <Fragment>
            <div className="row form-row">
                <div className="col-md-12">
                    {(view).map((field) => {
                        return fields.indexOf(field) !== -1 ? <div>
                            {!props.disabled && <span className={"btn btn-danger btn-xs"} onClick={(e) => {
                                e && e.preventDefault();
                                if (view.indexOf(field) !== -1) {
                                    view.splice(view.indexOf(field),1);
                                }
                                this.props.setFieldValue("views." + this.props.viewname + "", view);
                            }}><Icon lib="fa" name="times" /></span>}
                            <a className="btn btn-xs" onClick={(e) => {
                                e && e.preventDefault();
                                this.props.fieldtab && this.props.fieldtab.setActiveTab(field);
                            }}>{field}</a>
                        </div> : null;
                    })}
                    <Select storeType={"local"} objectValue={false} options={fieldoptions} valueKey={"key"} labelKey={"key"} label={false}
                            saveChanges={(field, value) => {
                                if (view.indexOf(value) === -1) {
                                    view.push(value);
                                }
                                this.props.setFieldValue("views." + this.props.viewname + "", view);
                            }} {...props}/>
                </div>
                <div>
                    {view.map((fieldname) => {
                        return fields.indexOf(fieldname) === -1 ? <div>
                            <Icon lib="fa" name="exclamation-triangle"/>
                            {fieldname}
                        </div> : null
                    })}
                </div>
            </div>
        </Fragment>
    }
}

class ComponentConfigForm extends React.Component {

    setFieldValue = (field, value) => {
        if (field.indexOf("componentconfig.") === 0) {
            const config = {componentconfig: JSON.parse(this.props.values.componentconfig || "{}") || {}};
            set(config, field, value);
            value = JSON.stringify(config.componentconfig, null, 4);
            field = "componentconfig";
        }
        if (field.indexOf("views.") === 0) {
            const config = {views: JSON.parse(this.props.values.views || "{}") || {}};
            set(config, field, value);
            value = JSON.stringify(config.views, null, 4);
            field = "views";
        }
        return this.props.setFieldValue(field, value);
    }

    removeField = (fieldname) => {
        if (confirm("Biztos?")) {
            const config = {componentconfig: JSON.parse(this.props.values.componentconfig || "{}") || {}};
            const fielddefs = config.componentconfig.fielddefs || {};
            delete fielddefs[fieldname];
            config.componentconfig.fielddefs = fielddefs;
            this.setFieldValue("componentconfig", JSON.stringify(config.componentconfig, null, 4));
        }
    }

    removeView = (viewname) => {
        if (confirm("Biztos?")) {
            const config = {views: JSON.parse(this.props.values.views || "{}") || {}};
            delete config.views[viewname];
            this.setFieldValue("views", JSON.stringify(config.views, null, 4));
        }
    }

    constructor(props) {
        super(props);
        const type = this.getComponentType(JSON.parse(this.props.values.componentconfig || "{}") || {});
        this.state = {
            componenttype: type
        }
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if (!isEqual(prevProps, this.props)) {
            const type = this.getComponentType(JSON.parse(this.props.values.componentconfig || "{}") || {});
            if (this.state.componenttype !== type) {
                this.setState({
                    componenttype: type
                });
            }
        }
    }

    getComponentType = (config) => {
        let componenttype = "Component";
        if (config.target || config.object === "ComponentDecorator") {
            componenttype = "ComponentDecorator";
        }
        if (config.objects || config.object === "Adapter") {
            componenttype = "Adapter";
        }
        return componenttype;
    }

    render() {
        const config = JSON.parse(this.props.values.componentconfig || "{}") || {};
        const fielddefs = config.fielddefs || {};
        const views = JSON.parse(this.props.values.views || "{}") || {};

        const fields = Object.keys(fielddefs);

        const idfieldoptions = [];
        fields.map((fieldname) => {
            if (fielddefs[fieldname].type === "attribute") {
                idfieldoptions.push({key: fieldname});
            }
        });

        const namepsaceoptions = [...nsoptions];
        if (config.ns && !namepsaceoptions.find((v) => v.key === config.ns)) {
            namepsaceoptions.push({key: config.ns});
        }

        const objectsoptions = [...(objectoptions[config.ns] || [])];
        if (config.object && !objectsoptions.find((v) => v.key === config.object)) {
            objectsoptions.push({key: config.object});
        }

        const ComponentType = componenttypes.find((c) => c.key === this.state.componenttype).Editor;

        return (
            <form onSubmit={this.props.handleSubmit}>
                <Box header={this.props.values.name}>
                    <div className="row form-row">
                        <div className="col-md-3">
                            <TextInput name={this.props.componentConfig.idfield} value={this.props.values[this.props.componentConfig.idfield]} label="Kód"
                                       role="idfield" {...this.props.getFieldProps(this.props.componentConfig.idfield)}/>
                        </div>
                        <div className="col-md-9">
                            <TextInput name="name" value={this.props.values.name} label="Név"
                                       saveChanges={this.setFieldValue} {...this.props.getFieldProps("name")}/>
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-9">
                            <Select isCreatAble={true} objectValue={false} valueKey={"key"} labelKey={"key"} storeType="local" options={namepsaceoptions} name="componentconfig.ns" value={config.ns} label="Ns"
                                   saveChanges={this.setFieldValue} {...this.props.getFieldProps("componentconfig.ns")}/>
                        </div>
                        <div className="col-md-3">
                            <Select isCreatAble={true} objectValue={false} valueKey={"key"} labelKey={"key"} storeType="local" options={objectsoptions} name="componentconfig.object" value={config.object} label="Object"
                                       saveChanges={this.setFieldValue} {...this.props.getFieldProps("componentconfig.object")}/>
                        </div>
                    </div>
                    <div className="row form-row">
                        <div className="col-md-3">
                            <Select storeType={"local"} objectValue={false} name="componentconfig.idfield" options={idfieldoptions} value={config.idfield} valueKey={"key"} labelKey={"key"} label="idfield"
                                    saveChanges={this.setFieldValue} {...this.props.getFieldProps("componentconfig.idfield")}/>
                        </div>
                        <div className="col-md-3">
                            <Select storeType={"local"} objectValue={false} options={componenttypes} value={this.state.componenttype} valueKey={"key"} labelKey={"key"} label="Típus"
                                    saveChanges={(field, value) => this.setState({componenttype: value})} {...this.props.getFieldProps("componentconfig.componenttype")}/>
                        </div>
                    </div>
                    <ComponentType componentconfig={config} getFieldProps={this.props.getFieldProps} setFieldValue={this.setFieldValue} />
                </Box>
                <Modal ref={(el) => this.newFieldModal = el} header={"Új fielddef"} buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default"},
                        onClose: true,
                        onClick: () => {
                            this.newFieldModal.hide();
                        }
                    },
                    {
                        text: "Mentés",
                        props: {color: "primary"},
                        onClose: true,
                        onClick: () => {
                            this.setFieldValue("componentconfig.fielddefs." + this.newFieldName.value, {});
                            this.fieldtab.setActiveTab(this.newFieldName.value);
                            this.newFieldModal.hide();
                        }
                    }
                ]}>
                    <TextInput ref={(newFieldName) => this.newFieldName = newFieldName} label="Név"
                               saveChanges={(field, value) => {this.newFieldName.value = value}}/>
                </Modal>
                <Box header="fielddefs" collapsed={true} footer={<Button icon={{lib: "fa", name: "plus"}} color="primary" onClick={(e) => {
                    this.newFieldModal.show();
                }}>Új</Button>}>
                    <Tabs
                        ref={(fieldtab) => this.fieldtab = fieldtab}
                        theme="default"
                        defaultTab={Object.keys(fielddefs)[0]}
                    >
                        {Object.keys(fielddefs).map((fieldname) => {
                            return <TabContent tabLabel={<Fragment>{fieldname} <Button icon={{lib: "fa", name: "times"}} size={"xs"} color="danger" onClick={(e) => {
                                e && e.preventDefault();
                                this.removeField(fieldname);
                            }}/></Fragment>} tabName={fieldname}><Field fieldname={fieldname} {...fielddefs[fieldname]} componentconfig={config} getFieldProps={this.props.getFieldProps} setFieldValue={this.setFieldValue}/></TabContent>
                        })}
                    </Tabs>
                </Box>
                <Modal ref={(el) => this.newViewModal = el} header={"Új fielddef"} buttons={[
                    {
                        text: "Mégse",
                        props: {color: "default"},
                        onClose: true,
                        onClick: () => {
                            this.newViewModal.hide();
                        }
                    },
                    {
                        text: "Mentés",
                        props: {color: "primary"},
                        onClose: true,
                        onClick: () => {
                            this.setFieldValue("views." + this.newViewName.value, []);
                            this.fieldtab.setActiveTab(this.newViewName.value);
                            this.newViewModal.hide();
                        }
                    }
                ]}>
                    <TextInput ref={(newViewName) => this.newViewName = newViewName} label="Név"
                               saveChanges={(field, value) => {this.newViewName.value = value}}/>
                </Modal>
                <Box header="views" collapsed={true} footer={<Button icon={{lib: "fa", name: "plus"}} color="primary" onClick={(e) => {
                    this.newViewModal.show();
                }}>Új</Button>}>
                    <Tabs
                        ref={(viewtab) => this.viewtab = viewtab}
                        theme="default"
                        defaultTab={Object.keys(views)[0]}
                    >
                        {Object.keys(views).map((viewname) => {
                            return <TabContent tabLabel={<Fragment>{viewname} <Button icon={{lib: "fa", name: "times"}} size={"xs"} color="danger" onClick={(e) => {
                                e && e.preventDefault();
                                this.removeView(viewname);
                            }}/></Fragment>} tabName={viewname}><View fieldtab={this.fieldtab} viewname={viewname} view={views[viewname]} componentconfig={config} getFieldProps={this.props.getFieldProps} setFieldValue={this.setFieldValue}/></TabContent>
                        })}
                    </Tabs>
                </Box>
                <Box>{this.props.footer}</Box>
            </form>
        );
    }
}

export default createForm(ComponentConfigForm);
